class Cartsummary {
  constructor(element, options) {
    this._options = { ...Cartsummary.options, ...options };
    this._element = element;
    this._cacheSelectors();
    this._initToggle();
  }

  _cacheSelectors() {
    this._toggles = this._element.querySelectorAll('.js-coupon');
  }

  _initToggle() {
    this._toggles.forEach((toggle) => {
      toggle.addEventListener('click', () => {
        // Get taget from attribute
        const targetId = toggle.dataset.target;
        // Get closest parent
        const parent = toggle.parentElement.closest('.discountcode');
        // Find the toggle target
        const target = parent.querySelector(`#${targetId}`);

        if (!target.classList.contains('is-active')) {
          toggle.classList.add('is-open');
          target.classList.add('is-active');
          target.style.height = 'auto';

          const height = `${target.clientHeight}px`;

          target.style.height = '0px';

          setTimeout(() => {
            target.style.height = height;
          }, 0);
        } else {
          toggle.classList.remove('is-open');
          target.style.height = '0px';

          target.addEventListener(
            'transitionend',
            () => {
              target.classList.remove('is-active');
            },
            {
              once: true,
            }
          );
        }
      });
    });
  }
}

export default Cartsummary;
